import React, { useEffect } from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { user as getUser } from '~data/selectors/user';
import { collection } from '~data/selectors/collections';
import { refresh as userRefresh } from '~data/actions/user';
import { load as collectionsLoad } from '~data/actions/collections';

import { Link } from 'react-router-dom';
import { Label, Progress } from '~ui';
import { LongDate } from '~modules/format/date';
import { fileSize } from '~modules/format/number';

const isMobile = navigator.userAgent.includes('RaindropMobile');

export default function SettingsAccountUsage() {
  const { _id, registered, files, pro } = useSelector(getUser);
  const allBookmarksCollection = useSelector((state) => collection(state, 0));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(userRefresh());
    dispatch(collectionsLoad());
  }, [dispatch]);

  return (
    <>
      {/* Type */}
      <Label>{t.s('accountType')}</Label>
      <div>
        {pro ? (
          <Link to='/settings/pro'>PRO {t.s('subscription')}</Link>
        ) : (
          t.s('free')
        )}
      </div>

      {/* Space */}
      <Label>{t.s('usedSpace')}</Label>
      <Progress
        min='0'
        max={files.size}
        value={files.used}
        valueText={t.format('ofMaxSize', fileSize(files.size))}
      >
        {fileSize(files.used)} {t.s('usedForUploads')}
        {!isMobile && !pro ? (
          <>
            . <Link to='/settings/pro'>{t.s('upgradeToPro')}</Link>
          </>
        ) : null}
      </Progress>

      <div />
      <Progress
        max={9999999999}
        value={allBookmarksCollection.count}
        valueText='∞'
      >
        {allBookmarksCollection.count} {t.s('bookmarks')}
      </Progress>

      {/* User */}
      <Label>User ID</Label>
      <div>{_id}</div>

      <Label>{t.s('registered')}</Label>
      <LongDate date={registered} />
    </>
  );
}
